export default "__VITE_ASSET__DLDdCdve__"